import script from "./ContactBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactBox.vue?vue&type=script&setup=true&lang=js"

import "./ContactBox.vue?vue&type=style&index=0&id=7dac56b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dac56b4"]])

export default __exports__